export const PROPRECSTATUS_WITHOUT_STATUS = 'PROPRECSTATUS_WITHOUT_STATUS'
export const PROPRECSTATUS_INTERESTED = 'PROPRECSTATUS_INTERESTED'
export const PROPRECSTATUS_NOT_INTERESTED = 'PROPRECSTATUS_NOT_INTERESTED'
export const PROPRECSTATUS_WITHDRAWN = 'PROPRECSTATUS_WITHDRAWN'
export const PROPRECSTATUS_REJECTED = 'PROPRECSTATUS_REJECTED'
export const PROPRECSTATUS_RESERVED = 'PROPRECSTATUS_RESERVED'
export const PROPRECSTATUS_INVITED = 'PROPRECSTATUS_INVITED'
export const PROPRECSTATUS_HIRED = 'PROPRECSTATUS_HIRED'
